import { forwardRef, type HTMLAttributes } from "react";

import { Link } from "react-router-dom";

import { cn } from "../lib/utils";

import logoUrl from "../assets/logo.png";

export interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "full" | "icon" | "compact";
  href?: string;
}

const LogoIcon = ({ className }: { className?: string }) => (
  <img src={logoUrl} alt="RC ACS" className={cn("h-8 w-8", className)} aria-hidden="true" />
);

const Logo = forwardRef<HTMLDivElement, LogoProps>(({ className, variant = "full", href, ...props }, ref) => {
  const content = (
    <div ref={ref} className={cn("inline-flex items-center gap-2 text-primary dark:text-white", className)} {...props}>
      <LogoIcon />
      {variant !== "icon" && (
        <div className="flex flex-col leading-tight">
          <span className="text-lg font-bold tracking-tight">RC</span>
          {variant === "full" && <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground dark:text-white/70">ACS</span>}
        </div>
      )}
    </div>
  );
  if (href) return <Link to={href} className="inline-flex no-underline" aria-label="RC ACS Início">{content}</Link>;
  return content;
});
Logo.displayName = "Logo";

export { Logo };
